import React from "react";
import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    question: "What services do you offer as an interior brand?",
    answer:
      "We offer End-to-End Interior Solutions right from design consultation to studio tours, VR, 2D drafting, manufacturing, and installation. We also offer a wide range of loose furniture & decor, appliances, lighting solutions, floor & wall concepts, and a lot more.",
  },
  {
    question: "How do I get started with your interior design services?",
    answer:
      "You can start by scheduling an initial consultation with our design team. During this meeting, we'll discuss your project, budget, and design preferences.",
  },
  {
    question: "Do you have experienced interior designers on your team?",
    answer:
      "Yes, we have a team of 50+ experienced and skilled interior designers who are ready to bring your design ideas to life.",
  },
  {
    question: "Can you work within my budget?",
    answer:
      "Absolutely. We understand that budget is an important factor in any project. Our designers will work with you to create a design that aligns with your budget and vision.",
  },
  {
    question: "What is the typical timeline for an interior design project?",
    answer:
      "We usually take around 45-90 working days, but the timeline can vary depending on the scope and complexity of your project. During the initial consultation, we'll provide you with an estimated timeline for your specific project.",
  },
  {
    question: "Can you help with both residential and commercial interior design projects?",
    answer:
      "Currently, we only provide residential interior design. But soon we shall cope with commercial interiors too.",
  },
  {
    question: "How do you ensure the quality of materials and workmanship in your projects?",
    answer:
      "We work with trusted suppliers who meet our quality standards. Our Project Managers also oversee the project to ensure that it meets our quality benchmarks. You can also visit our factory to ensure our quality is up to your expectations.",
  },
  {
    question: "Do you offer any warranties on your interior design work?",
    answer:
      "Yes, we provide up to a 10-year warranty on our work with Post-Sale Service to ensure your satisfaction with the final result.",
  },
  {
    question: "What areas do you serve?",
    answer:
      "We provide our interior design services across Bangalore, Hyderabad, Chennai, and expanding to Pune, Mumbai, and Delhi. You can visit our experience centers in HSR Layout, HRBR Layout, JP Nagar, Whitefield, Gachibowli, and Velachery.",
  },
];

export const FAQSection = () => {
  return (
    <section id="faq" className="section bg-muted/30">
      <div className="container max-w-4xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <p className="uppercase tracking-[0.3em] text-[11px] text-muted-foreground mb-4">
            Have Questions?
          </p>
          <h2 className="font-display text-4xl md:text-5xl font-semibold text-foreground">
            Questions, Answered
          </h2>
          <p className="mt-4 text-muted-foreground max-w-2xl mx-auto">
            Find answers to commonly asked questions about our services, process,
            and expertise.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {faqs.map((faq, index) => (
              <AccordionItem key={index} value={`item-${index}`} className="border-[hsl(var(--border))]">
                <AccordionTrigger className="text-left font-serif-alt text-base hover:text-[hsl(var(--brand-gold))] transition-colors">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};

export default FAQSection;
